import { IProductImage } from './types';

export const productImageProps: IProductImage = {
  objectFitContain: true,
};
